import React from 'react'
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';

const DatePickerRanges = () => {
    const predefinedBottomRanges: any = [
      {
        label: "Today",
        value: [new Date(), new Date()],
      },
      {
        label: "Yesterday",
        value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      },
    //   {
    //     label: "This week",
    //     value: [startOfWeek(new Date()), endOfWeek(new Date())],
    //   },
      {
        label: "Last 7 Days",
        value: [subDays(new Date(), 6), new Date()],
      },
      {
        label: "Last 15 Days",
        value: [subDays(new Date(), 14), new Date()],
      },
      {
        label: "This Month",
        value: [startOfMonth(new Date()), endOfMonth(new Date())],
      },
      {
        label: "Last Month",
        value: [
          startOfMonth(addMonths(new Date(), -1)),
          endOfMonth(addMonths(new Date(), -1)),
        ],
      },
      {
        label: "This Year",
        value: [
          new Date(new Date().getFullYear(), 0, 1),
          new Date(new Date().getFullYear(), 11, 31),
        ],
      },      
    //   {
    //     label: "Last year",
    //     value: [
    //       new Date(new Date().getFullYear() - 1, 0, 1),
    //       new Date(new Date().getFullYear(), 0, 0),
    //     ],
    //   },
      
    ];
  return predefinedBottomRanges;
}

export default DatePickerRanges;